import CryptoJs from 'crypto-js'
import { BASE_URL } from '@/utils/host'

export default {
  /**
   * 验证是否为汉字
   * true 说明合格
   * @param {*} val 
   */
  isSinogram:function(val) {
    let reg = /^[\u4e00-\u9fa5]$/
    if(!reg.test(val)) {
      return false
    } else {
      return true
    }
  },
/*
 * 验证手机号是否合格
 * true--说明合格
 */
isPhone:function(phoneStr) {
    let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
    if (!myreg.test(phoneStr)) {
      return false;
    } else {
      return true;
    }
  },
  
  /*
   * 验证身份证号是否合格
   * true--说明合格
   */
isIdCard: function (idCardStr) {
    let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    if (idcardReg.test(idCardStr)) {
      return true;
    } else {
      return false;
    }
},
  
  /**
   * 验证车牌号是否合格
   * true--说明合格
   */
isVehicleNumber:function (vehicleNumber) {
    let xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
    let creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
    if (vehicleNumber.length == 7) {
      return creg.test(vehicleNumber);
    } else if (vehicleNumber.length == 8) {
      return xreg.test(vehicleNumber);
    } else {
      return false;
    }
},
  
  /*
   * 验证字符串是否为空（也不能为纯空格）
   * true--说明为空， false--说明不为空
   */
  isEmptyString:function (string) {
    if (
      string == undefined ||
      typeof string == 'undefined' ||
      !string ||
      string == null ||
      string == '' ||
      /^\s+$/gi.test(string)
    ) {
      return true;
    } else {
      return false;
    }
  },
  
  /*
   * 生日转为年龄（精确到月份）
   */
  birsdayToAge:function (birsday) {
    let aDate = new Date();
    let thisYear = aDate.getFullYear();
    let bDate = new Date(birsday);
    let brith = bDate.getFullYear();
    let age = thisYear - brith;
    if (aDate.getMonth() == bDate.getMonth()) {
      if (aDate.getDate() < bDate.getDate()) {
        age = age - 1;
      }
    } else {
      if (aDate.getMonth() < bDate.getMonth()) {
        age = age - 1;
      }
    }
    return age;
  },
  
  /**
   * 判断数据类型
   * @param {any} val - 基本类型数据或者引用类型数据
   * @return {string} - 可能返回的结果有，均为小写字符串
   * number、boolean、string、null、undefined、array、object、function等
   */
   getType: function (val){
    //判断数据是 null 和 undefined 的情况
    if (val == null) {
      return val + "";
    }
    return typeof(val) === "object" ?
        Object.prototype.toString.call(val).slice(8, -1).toLowerCase() :
        typeof(val);
  },
  
  /*
   * 验证是否为数字
   */
  isNumber: function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  },
  
  /*
   * 是否为数组
   */
  isArray: function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  },
  
  /*
   * 是否空数组
   */
  isArrayEmpty: function (val) {
    if (val && val instanceof Array && val.length > 0) {
      return false;
    } else {
      return true;
    }
  },
  
  /*
   * 获取url参数字符串
   * 没有返回null
   */
  getQueryString: function (name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  },
  
  /*
   * 递归深拷贝
   */
  deepCopy: function (obj) {
    let result = Array.isArray(obj) ? [] : {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          result[key] = this.deepCopy(obj[key]);
        } else {
          result[key] = obj[key];
        }
      }
    }
    return result;
  },
  
  /**
   * 去除参数空数据（用于向后台传递参数的时候）
   * @param {Object} obj [参数对象]
   */
   filterEmptyData: function (obj) {
    for (let prop in obj) {
      obj[prop] === '' ? delete obj[prop] : obj[prop];
    }
    return obj;
  },
  
  /**
   * @desc  函数防抖，用于将多次执行变为最后一次执行
   * @param {function} func - 需要使用函数防抖的被执行的函数。必传
   * @param {Number} wait - 多少毫秒之内触发，只执行第一次，默认1000ms。可以不传
   */
   debounce: function (fn, delay) {
    delay = delay || 1000; //默认1s后执行
    let timer = null;
    return function () {
      let context = this;
      let arg = arguments;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        fn.apply(context, arg);
      }, delay);
    };
  },
  
  /**
   * 节流函数, 用于将多次执行变为每隔一段时间执行
   * @param fn 事件触发的操作
   * @param delay 间隔多少毫秒需要触发一次事件
   */
   throttle2: function (fn, delay) {
    let timer = null;
    return function () {
      let context = this;
      let args = arguments;
      if (!timer) {
        timer = setTimeout(function () {
          fn.apply(context, args);
          clearTimeout(timer);
        }, delay);
      }
    };
  },
  
  // 数字四舍五入（保留n位小数）
  round: function  (number, n) {
      n = n ? parseInt(n) : 0
      if (n <= 0) return Math.round(number)
      number = Math.round(parseFloat((number * Math.pow(10, n)).toPrecision(12))) / Math.pow(10, n)
      return number
  },
  /**
   *  验证正负数 保留两位小数
   * @param {*} values 
   * @returns 
   */
  plusOrMinus: function (values){
    let newValue
    if (!(/[^0-9.-]/g.test(values))) {
      newValue = values.replace(/[^\-\d.]/g, '').replace(/\b(0+){2,}/g, '0').replace(/\-{2,}/g, '-').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[1].length) > 2) {
        newValue = parseInt(parseFloat(newValue) * 100) / 100
      }
      if ((newValue.toString().split('-').length - 1) > 1) {
        newValue = parseFloat(newValue) || ''
      }
      if ((newValue.toString().split('-').length) > 1 && newValue.toString().split('-')[0].length > 0) {
        newValue = parseFloat(newValue) || ''
      }
      if (newValue.toString().length > 1 && (newValue.toString().charAt(0) === '0' || (newValue.toString().length > 2 && newValue.toString().charAt(0) === '-' && newValue.toString().charAt(1) === '0' && newValue.toString().charAt(2) !== '.')) && newValue.toString().indexOf('.') < 1) {
        newValue = parseFloat(newValue) || ''
      }
      // 判断整数位最多为9位
      if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[0].length) > 9) {
        newValue = newValue.toString().substring(0, 9) + '.' + newValue.toString().split('.')[1]
      } else if (newValue.toString().indexOf('.') < 0 && Number(newValue.toString().split('.')[0].length) > 9) {
        newValue = newValue.toString().substring(0, 9)
      }
    } else {
      newValue = values.replace(/[^0-9.-]/g, '')
    }
    return newValue
  },
  /**
   * 验证正数 保留两位小数
   * @param {*} value 
   * @returns 
   */
  plusDigit: function (value){
    return ('' + value) // 第一步：转成字符串
    .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
    .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
    .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
    .match(/^\d*(\.?\d{0,2})/g)[0] || '' // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
  },
  /**
   *数字金额转文字  函数
   *
   * @export
   * @param {*} money
   * @returns
   */
   convertCurrency: function (money) {
    //汉字的数字
    var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
    //基本单位
    var cnIntRadice = new Array('', '拾', '佰', '仟');
    //对应整数部分扩展单位
    var cnIntUnits = new Array('', '万', '亿', '兆');
    //对应小数部分单位
    var cnDecUnits = new Array('角', '分', '毫', '厘');
    //整数金额时后面跟的字符
    var cnInteger = '整';
    //整型完以后的单位
    var cnIntLast = '元';
    //最大处理的数字
    var maxNum = 999999999999999.9999;
    //金额整数部分
    var integerNum;
    //金额小数部分
    var decimalNum;
    //输出的中文金额字符串
    var chineseStr = '';
    //分离金额后用的数组，预定义
    var parts;
    if (money == '') {
      return '';
    }
    money = parseFloat(money);
    if (money >= maxNum) {
      //超出最大处理数字
      return '';
    }
    if (money == 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger;
      return chineseStr;
    }
    //转换为字符串
    money = money.toString();
    if (money.indexOf('.') == -1) {
      integerNum = money;
      decimalNum = '';
    } else {
      parts = money.split('.');
      integerNum = parts[0];
      decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      var zeroCount = 0;
      var IntLen = integerNum.length;
      for (var i = 0; i < IntLen; i++) {
        var n = integerNum.substr(i, 1);
        var p = IntLen - i - 1;
        var q = p / 4;
        var m = p % 4;
        if (n == '0') {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0];
          }
          //归零
          zeroCount = 0;
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
        }
        if (m == 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q];
        }
      }
      chineseStr += cnIntLast;
    }
    //小数部分
    if (decimalNum != '') {
      var decLen = decimalNum.length;
      for (var i = 0; i < decLen; i++) {
        var n = decimalNum.substr(i, 1);
        if (n != '0') {
          chineseStr += cnNums[Number(n)] + cnDecUnits[i];
        }
      }
    }
    if (chineseStr == '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == '') {
      chineseStr += cnInteger;
    }
    return chineseStr;
  },
  
  
  /*
   *时间增加或减少几天
   * date  当前日期 例： 2020-06-10
   * days  增加的天数 例： 30
   * return 增加后的天数
   */
   addDate: function (date, days) {
    var d = new Date(date);
    d.setDate(d.getDate() + days);
    var month = d.getMonth() + 1;
    var day = d.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    var val = d.getFullYear() + "-" + month + "-" + day;
    return val;
  },
  
  /*
   *数字每千位加逗号
   * 
   */
   commafy: function (num) {
    return num && num.toString()
      .replace(/\d+/, function(s){
           return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
       })
  },
  
  
  /*
   *数字补位
   * numberPad用于按照位数补0,默认为2
   */
   numberPad: function (source, length = 2) {
    let pre = ''
    const negative = source < 0
    const string = String(Math.abs(source))
    if (string.length < length) {
      pre = (new Array(length - string.length + 1)).join('0')
    }
    return (negative ? '-' : '') + pre + string
  },
  
    /*
    *随机数
    *
    */
    numberRandom: function  (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    },
  /*
   *手机号码中间4位隐藏花号（*）显示
   *
   */
    hideMobile: function (mobile) {
        return mobile.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2")
    },
  
  
    /**
     * 去除字符串空格
     * @param str 要处理的字符串
     * @param type 1：所有空格 2：前后空格 3：前空格 4：后空格
     */
    strTrim: function (str, type) {
        switch (type) {
            case 1:
                return str.replace(/\s+/g, "");
            case 2:
                return str.replace(/(^\s*)|(\s*$)/g, "");
            case 3:
                return str.replace(/(^\s*)/g, "");
            case 4:
                return str.replace(/(\s*$)/g, "");
            default:
                return str;
        }
    },
  
    /**
     * 字母大小写切换
     * @param str 要处理的字符串
     * @param type 1:首字母大写 2：首页母小写 3：大小写转换 4：全部大写 5：全部小写
     */
     strChangeCase: function (str, type) {
          function ToggleCase(str) {
              var itemText = ""
              str.split("").forEach(
                  function (item) {
                      if (/^([a-z]+)/.test(item)) {
                          itemText += item.toUpperCase();
                      } else if (/^([A-Z]+)/.test(item)) {
                          itemText += item.toLowerCase();
                      } else {
                          itemText += item;
                      }
                  });
              return itemText;
          }
  
          switch (type) {
              case 1:
                  return str.replace(/^(\w)(\w+)/, function (v, v1, v2) {
                      return v1.toUpperCase() + v2.toLowerCase();
                  });
              case 2:
                  return str.replace(/^(\w)(\w+)/, function (v, v1, v2) {
                      return v1.toLowerCase() + v2.toUpperCase();
                  });
              case 3:
                  return ToggleCase(str);
              case 4:
                  return str.toUpperCase();
              case 5:
                  return str.toLowerCase();
              default:
                  return str;
          }
      },
  
    /**
     * 检测密码强度
     * @param str 字符串
     * @returns 1：密码弱 2：密码中等 3：密码强 4：密码很强
     */
    checkPwd: function (str) {
        var nowLv = 0;
        if (str.length < 6) {
            return nowLv
        };
        if (/[0-9]/.test(str)) {
            nowLv++
        };
        if (/[a-z]/.test(str)) {
            nowLv++
        };
        if (/[A-Z]/.test(str)) {
            nowLv++
        };
        return nowLv;
    },
  
    /**
     * 简单数组排序，针对数字数组
     * @param type 1：降序，0：升序
     */
    sortArr: function (arr, type) {
        if (type == 1) {
            //降序
            arr.sort(function (a, b) {
                return b - a;
            });
        } else {
            arr.sort(function (a, b) {
                return a - b;
            });
        }
        return arr;
    },
  
  
    /**
     
    * 浏览器全屏
    
    */
   reqFullScreen: function (element){
        if (element.requestFullScreen) {
          element.requestFullScreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
    },
  
    /**
     
    * 浏览器退出全屏
    
    */
    exitFullScreen: function() {
      if(document.exitFullscreen) {
          document.exitFullscreen();
      } else if(document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
      } else if(document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
      } else if(document.msExitFullscreen) {
          document.msExitFullscreen();
      }
    },
  
  
   /**
     * 加密
     * @param {*} value 值
     * @param {*} keyStr 秘钥
     * @returns 
     */
    getEncrypt: function(value, keyStr) {
        keyStr = keyStr ? keyStr : 'ABGHNJHGSHUYG1234567890';
        const keyHex = CryptoJs.enc.Utf8.parse(keyStr)
        const option = { mode: CryptoJs.mode.ECB, padding: CryptoJs.pad.Pkcs7 }
        const encrypted = CryptoJs.DES.encrypt(value, keyHex, option)
        return encrypted.ciphertext.toString() // 返回hex格式密文，如需返回base64格式：encrypted.toString() 
    },
    /**
     * 解密
     * @param {*} value 值
     * @param {*} keyStr 秘钥
     */
    getDecrypt: function(value, keyStr) {
        keyStr = keyStr ? keyStr : 'ABGHNJHGSHUYG1234567890';
        const keyHex = CryptoJs.enc.Utf8.parse(keyStr)
        const decrypted = CryptoJs.DES.decrypt(
        {
            ciphertext: CryptoJs.enc.Hex.parse(value)
        },// 若message是base64格式，则无需转16进制hex，直接传入message即可
        keyHex,
        {
            mode: CryptoJs.mode.ECB,
            padding: CryptoJs.pad.Pkcs7
        })
        return decrypted.toString(CryptoJs.enc.Utf8)
    },
    /** 参数加密 */
    paramsEncrypt: function (params = {}) {
      for (let prop in params) {
        if (params[prop] != null) {
          params[prop] = this.getEncrypt(params[prop])
        }
      }
    },
    /** 文件下载*/
    downLoad: function (url,name){
      const a = document.createElement('a')
      const body = document.querySelector('body')
      a.href = url
      a.download = name
      body.append(a)
      a.click()
      a.remove()
    },
    //id转名称
    findOrgIdToName:function(arr,orgid,_name){
      arr.forEach(item => {
        if (item.orgid == orgid) {
          _name = item.orgname;
        } else{
          if (item.children && item.children.length) {
            const p = this.findOrgIdToName(item.children, orgid);
            if(p) _name = p;
          }
        }
      });
      return _name;
    },
    /**
     * 转UTC时间格式
     * @param {time} time 如果是'start'表示本年度的1月1日00:00:00 ,如果是'end'表示本年度的12月31日23:59:59 ,time也可以是Date构造函数的实参
     * @returns String UTC格式的时间字符串
     */
    formatDateToUtc:function(time) {
      const curDate = new Date()
      const curYear = curDate.getFullYear()
      if (time === 'start') {
        return new Date(`${curYear}-1-1`).toISOString()
      } else if (time === 'end') {
        return new Date(`${curYear + 1}-1-1`).toISOString()
      } else {
        return new Date(time).toISOString()
      }
    },
    /**
     * UTC时间转正常时间
     * @param {*} timer 
     * @returns 
     */
    dateUtcToFormat:function(timer) {
      let date = new Date(timer)
      let y = String(date.getFullYear()).padStart(4, 0)
      let M = String(date.getMonth() + 1).padStart(2, 0)
      let d = String(date.getDate()).padStart(2, 0)
      let h = String(date.getHours()).padStart(2, 0)
      let m = String(date.getMinutes()).padStart(2, 0)
      let s = String(date.getSeconds()).padStart(2, 0)
      return `${y}-${M}-${d} ${h}:${m}:${s}`
    },
    /**
     * 时间戳转正常时间
     * @param {*} time 
     * @param {*} format 
     * @returns 
     */
    dateFormat(time, format = "YYYY-MM-DD HH:mm:ss") {
      if(!time) {
        return null
      }
      let date = new Date(time)
      const config = {
        YYYY: date.getFullYear(),
        MM: date.getMonth() + 1,
        DD: date.getDate(),
        HH: date.getHours(),
        mm: date.getMinutes(),
        ss: date.getSeconds()
      };
      for (const key in config) {
        format = format.replace(key, this.padLeftZero(config[key]));
      }
      return format;
    },
    padLeftZero(str) {
        if(parseInt(str)<10){
            return '0'+str;
        }
        return str;
    },
    /**
     * 截取字符串后N位
     * @param {String} str 字符串
     * @param {Number} num n位
     */
    substrAfter(str,num) {
      if(this.isEmptyString(str)) {
        return '';
      } 
      if(str.length < num) {
        return '';
      }
      return str.substring(str.length - num);
    },
    /**
     * 根据对象key获取value
     * @param {Object} obj 对象
     * @param {String} key key
     * @param {String} defaultValue 默认-
     * @returns 
     */
    getObjectValue(obj, key, defaultValue) {
      if(!obj) {
        return defaultValue ? defaultValue : null;
      }
      // 分割key
      var keyList = key.split('.')
      for(let k in obj) {
        if(k === keyList[0]) {
          if(!obj[k]) {
            return defaultValue ? defaultValue : obj[k]
          } else {
            if(Object.prototype.toString.call(obj[k]).slice(8, -1).toLowerCase() === 'object') {
              keyList.splice(0,1)
              return this.getObjectValue(obj[k],keyList.join('.'))
            } else {
              return obj[k]
            }
          }
        }
      }
    },
    /**
     * 页面跳转
     * @param {*} url 跳转路径
     * @param {*} hrefType 跳转类型（hrefType = open: 另起一个窗口打开。hrefType = replace: 在当前页面打开）
     * 
     */
    open(url, hrefType='open') {
      const HOME_WORK = BASE_URL.HOME_WORK
      const s = url.substring(0,1)
      let _url = ''
      s === '/'? _url = HOME_WORK + url : _url = HOME_WORK + `/${url}`
      hrefType === 'open' ? window.open(_url, '_blank') : window.location.replace(_url)
    }
}
